class OrderSearchServiceClass {
  get orderIdRegex() {
    return /(?:\^[#£]\^)(.*)(?:\^)/;
  }

  getOrderId(searchString) {
    if (this.isThisAnOrderId(searchString)) {
      const { orderIdRegex } = this;

      const firstMatchedGroupIndex = 1;
      const match = orderIdRegex.exec(searchString);
      return match[firstMatchedGroupIndex];
    }
    return '';
  }

  isThisAnOrderId(searchString) {
    const { orderIdRegex } = this;
    return searchString !== 'escape' && orderIdRegex.test(searchString);
  }

  shipmentNumberSelected(previousShipmentNumber, currentShipmentNumber) {
    if (previousShipmentNumber !== currentShipmentNumber) {
      if (typeof currentShipmentNumber === 'number') {
        return currentShipmentNumber !== 0;
      }

      if (typeof currentShipmentNumber === 'string') {
        return currentShipmentNumber.length !== 0 && currentShipmentNumber !== '0';
      }
    }

    return false;
  }
}

export const OrderSearchService = new OrderSearchServiceClass();
